/* Solacely 2026 — Mobile Nav + Footer Accordion */
(function () {
  var hamburger  = document.getElementById('hamburger');
  var mobileMenu = document.getElementById('mobile-menu');
  var backdrop   = document.getElementById('nav-backdrop');
  var closeBtn   = document.getElementById('mobile-close');
  var mobileLinks = mobileMenu ? mobileMenu.querySelectorAll('a') : [];

  if (!hamburger || !mobileMenu) return;

  function openMenu() {
    mobileMenu.classList.add('is-open');
    backdrop.classList.add('is-visible');
    hamburger.classList.add('is-active');
    hamburger.setAttribute('aria-expanded', 'true');
    mobileMenu.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (closeBtn) closeBtn.focus();
  }

  function closeMenu() {
    mobileMenu.classList.remove('is-open');
    backdrop.classList.remove('is-visible');
    hamburger.classList.remove('is-active');
    hamburger.setAttribute('aria-expanded', 'false');
    mobileMenu.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    hamburger.focus();
  }

  hamburger.addEventListener('click', function () {
    mobileMenu.classList.contains('is-open') ? closeMenu() : openMenu();
  });

  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  if (backdrop) backdrop.addEventListener('click', closeMenu);

  mobileLinks.forEach(function (link) {
    link.addEventListener('click', closeMenu);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && mobileMenu.classList.contains('is-open')) closeMenu();
  });

  mobileMenu.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var focusable = mobileMenu.querySelectorAll('a, button, input, [tabindex]:not([tabindex="-1"])');
    var first = focusable[0];
    var last  = focusable[focusable.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first) { e.preventDefault(); last.focus(); }
    } else {
      if (document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
})();

/* Footer accordion (mobile only) */
(function () {
  var accordionBtns = document.querySelectorAll('.footer__nav-group .footer__col-heading');

  accordionBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (window.innerWidth > 767) return;
      var targetId = btn.getAttribute('aria-controls');
      var navList  = document.getElementById(targetId);
      if (!navList) return;
      var isOpen = navList.classList.contains('is-open');
      accordionBtns.forEach(function (other) {
        var otherId   = other.getAttribute('aria-controls');
        var otherList = document.getElementById(otherId);
        if (other !== btn && otherList) {
          otherList.classList.remove('is-open');
          other.setAttribute('aria-expanded', 'false');
        }
      });
      if (isOpen) {
        navList.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
      } else {
        navList.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
})();



(function() {
  var header = document.querySelector('.nav');
  var lastScroll = 0;
  var scrollThreshold = 100;

  window.addEventListener('scroll', function() {
    var currentScroll = window.scrollY || document.documentElement.scrollTop;

    if (currentScroll > scrollThreshold) {
      if (currentScroll > lastScroll) {
        header.classList.remove('sticky-visible');
        header.classList.add('sticky-hidden');
      } else {
        header.classList.remove('sticky-hidden');
        header.classList.add('sticky-visible');
      }
    } else {
      header.classList.remove('sticky-hidden', 'sticky-visible');
    }

    lastScroll = currentScroll;
  }, { passive: true });
})();

(function() {
  var header = document.querySelector('.nav');
  window.addEventListener('scroll', function() {
    header.classList.toggle('is-sticky', window.scrollY > 100);
  }, { passive: true });
})();